<template>
  <div class="racontrols text-noselect">
    <div
      class="f-center"
      tour="rbtopcontrols"
    >
      <div
        class="mdi mdi-chevron-left icon_btn racontrols_icon csst csst_nm"
        style="padding: 0.125rem"
        :class="{ 'opacity_4 no-events': backDisabled }"
        @click="$emit('click:go', -1)"
        @mouseenter="e => fl_positionTooltip(e, { placement: 'bottom' })"
      >
        <div
          class="csst_content"
          style="position: fixed"
        >
          {{ $t('common.undo') }}
          <span class="text-small keyboardkey_key">Control</span> +
          <span class="text-small keyboardkey_key">Z</span>
        </div>
      </div>
      <div
        class="mdi mdi-chevron-right icon_btn racontrols_icon csst csst_nm"
        style="padding: 0.125rem"
        :class="{ 'opacity_4 no-events': forwardDisabled }"
        @click="$emit('click:go', 1)"
        @mouseenter="e => fl_positionTooltip(e, { placement: 'bottom' })"
      >
        <div
          class="csst_content"
          style="position: fixed"
        >
          {{ $t('common.redo') }}
          <span class="text-small keyboardkey_key">Control</span> +
          <span class="text-small keyboardkey_key">Y</span>
        </div>
      </div>
    </div>
    <div
      v-if="!canClear"
      class="gw_btn gw_btn_text racontrols_text weight_500"
      :class="{ 'opacity_4 no-events': backDisabled && forwardDisabled }"
      @click=";(canClear = !canClear), (canConfirm = false)"
    >
      <!-- {{ $t('btn.clear') }} -->
      {{ $t('btn.reset') }}
    </div>
    <div
      v-if="canClear"
      class="gw_btn racontrols_test weight_500"
      @click="canClear = !canClear"
    >
      {{ $t('btn.cancel') }}
    </div>
    <div
      v-if="canClear"
      class="gw_btn gw_btn_primary racontrols_test weight_500"
      @click="$emit('click:clear'), (canClear = false)"
    >
      {{ $t('btn.confirm') }}
    </div>
  </div>
</template>

<script>
import float_mix from '@/mixins/float_mix'

export default {
  name: 'RangeBuilderControls',
  mixins: [float_mix],
  props: {
    backDisabled: Boolean,
    forwardDisabled: Boolean,
  }, 
 emits: ['click:go','click:clear'],
  data() {
    return {
      canClear: false,
      canConfirm: false,
    }
  },
}
</script>
<style lang="scss" scoped>
.racontrols {
  --icon-font-size: 1rem;
  --text-font-size: 0.875rem;
  --max-height: 1.65rem;
  display: flex;
  gap: 0.25rem;
  padding: 0 0.25rem;
  background: var(--clr-black-1);
  border-radius: 6px;
  align-items: center;
  justify-content: center;
  max-height: var(--max-height);
  &_icon {
    font-size: var(--icon-font-size);
  }
  &_text {
    font-size: var(--text-font-size);
  }
}
</style>
